<template>
  <transition name="message-fade">
    <div
      ref="message"
      :class="['message', `message-${type}`]"
      v-show="visible"
      @mouseenter="stopTimer"
      @mouseleave="startTimer">
      <img :src="src" class="message-icon" alt="消息图标">
      <span class="message-content">{{ content }}</span>
    </div>
  </transition>
  <!--</div>-->
</template>

<script>
  import successIcon from '@/assets/success.png';
  import errorIcon from '@/assets/error.png';
  import warnIcon from '@/assets/warning.png';
  import infoIcon from '@/assets/info.png';

  export default {
    name: 'message',
    data () {
      return {
        type: 'info',
        content: '',
        src: successIcon,
        onClosed: null,
        visible: false,
        timer: null,
        delay: 3000
      };
    },
    methods: {
      destroyElement () {
        this.$el.removeEventListener('transitionend', this.destroyElement);
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      },

      collapseMessage () {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      },

      startTimer () {
        this.timer = setTimeout(() => {
          this.collapseMessage();
        }, this.delay);
      },

      stopTimer () {
        clearTimeout(this.timer);
      }
    },
    beforeMount () {
      switch (this.type) {
        case 'info': this.src = infoIcon; break;
        case 'success': this.src = successIcon; break;
        case 'error': this.src = errorIcon; break;
        case 'warning': this.src = warnIcon; break;
      }
    },
    mounted () {
      this.startTimer();
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "style.scss";
</style>
